import { PropsWithChildren, createContext, useContext } from "react";

import { IBuildingPropsPermissions } from "../Building";

const BuildingPermissionsContext = createContext<IBuildingPropsPermissions>({} as IBuildingPropsPermissions);

export const BuildingPermissionsContextProvider = ({
  children,
  ...permissions
}: PropsWithChildren & IBuildingPropsPermissions) => {
  return <BuildingPermissionsContext.Provider value={permissions}>{children}</BuildingPermissionsContext.Provider>;
};

export const useBuildingPermissionsContext = () => useContext(BuildingPermissionsContext);
